document.addEventListener('DOMContentLoaded', () => {
  /* Legacy one-variant purchase controls retained only for reference.
  const purchaseRoot = document.querySelector('[data-product-purchase]');
  const quantity = purchaseRoot?.querySelector('#quantity');
  const price = purchaseRoot?.querySelector('[data-price]:not(input)');
  const comparePrice = purchaseRoot?.querySelector('[data-compare-price]:not(input)');
  const addToCart = purchaseRoot?.querySelector('.add-to-cart');
  let selectedPriceCents = Number(price?.dataset.priceCents || 0);

  const formatMoney = (cents) => `$${(cents / 100).toFixed(2)}`;
  const updatePurchaseTotal = () => {
    if (!quantity || !price || !addToCart) return;
    const units = Math.max(1, Number(quantity.value || 1));
    quantity.value = units;
    const total = selectedPriceCents * units;
    price.textContent = formatMoney(total);
    addToCart.textContent = `Add to bag — ${formatMoney(total)}`;
  };

  (purchaseRoot?.querySelectorAll('[data-quantity]') || []).forEach((button) => {
    button.addEventListener('click', () => {
      const step = button.dataset.quantity === 'plus' ? 1 : -1;
      quantity.value = Math.max(1, Number(quantity.value || 1) + step);
      updatePurchaseTotal();
    });
  });

  quantity?.addEventListener('change', updatePurchaseTotal);

  const productForm = purchaseRoot?.querySelector('#wakeplay-product-form');
  const addOnInputs = [...(purchaseRoot?.querySelectorAll('[data-cart-add-on]') || [])];
  const upsellOptions = purchaseRoot?.querySelector('.upsell-options');

  if (productForm && upsellOptions && addToCart) {
    productForm.insertBefore(upsellOptions, addToCart);
  }

  const syncAddOnTotal = () => {
    const selectedInput = purchaseRoot?.querySelector('input[name="id"]:checked, input[name="id"][type="hidden"]');
    const baseCents = Number(selectedInput?.dataset.priceCents || price?.dataset.priceCents || 0);
    const addOnCents = addOnInputs
      .filter((option) => option.checked)
      .reduce((sum, option) => sum + Number(option.dataset.upsellPriceCents || 0), 0);
    selectedPriceCents = baseCents + addOnCents;
    updatePurchaseTotal();
  };

  addOnInputs.forEach((option) => option.addEventListener('change', syncAddOnTotal));
  syncAddOnTotal();
  productForm?.addEventListener('submit', async (event) => {
    const addOns = [...purchaseRoot.querySelectorAll('[data-cart-add-on]:checked')];
    event.preventDefault();
    if (!addToCart || addToCart.dataset.loading === 'true') return;

    const selectedVariantId = new FormData(productForm).get('id');
    const units = Math.max(1, Number(quantity?.value || 1));
    if (!selectedVariantId) return;

    const originalText = addToCart.textContent;
    addToCart.dataset.loading = 'true';
    addToCart.disabled = true;
    addToCart.textContent = 'Adding to bag…';

    try {
      const items = [
        { id: Number(selectedVariantId), quantity: units },
        ...addOns.map((option) => ({ id: Number(option.dataset.upsellVariantId), quantity: units })),
      ];
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error('Could not add optional protection.');
      sessionStorage.setItem('useful-joy-cart-drawer-open', 'true');
      window.location.reload();
    } catch (error) {
      addToCart.disabled = false;
      addToCart.dataset.loading = 'false';
      addToCart.textContent = originalText;
      window.alert('We could not add the optional protection. Please try again.');
    }
  });

  (purchaseRoot?.querySelectorAll('input[name="id"]') || []).forEach((input) => {
    input.addEventListener('change', () => {
      if (!input.checked) return;
      const picker = input.closest('.variant-picker');
      picker?.querySelectorAll('[data-variant-choice]').forEach((choice) => {
        choice.classList.toggle('is-selected', choice.dataset.variantId === input.value);
      });
      const addOnCents = addOnInputs
        .filter((option) => option.checked)
        .reduce((sum, option) => sum + Number(option.dataset.upsellPriceCents || 0), 0);
      selectedPriceCents = Number(input.dataset.priceCents || 0) + addOnCents;
      comparePrice.textContent = input.dataset.comparePrice;
      comparePrice.hidden = !input.dataset.comparePrice || input.dataset.comparePrice === '$0.00';
      const gallery = document.querySelector('[data-product-gallery]');
      const galleryIndex = Number(input.dataset.variantGalleryIndex);
      const galleryThumbs = gallery ? [...gallery.querySelectorAll('[data-gallery-thumb]')] : [];
      if (Number.isInteger(galleryIndex) && galleryThumbs[galleryIndex]) {
        galleryThumbs[galleryIndex].click();
      } else if (input.dataset.variantImage && !document.querySelector('.product-page--alarm')) {
        const mainImage = gallery?.querySelector('[data-gallery-main]');
        if (mainImage) {
          mainImage.src = input.dataset.variantImage;
          mainImage.alt = input.dataset.variantImageAlt || 'Selected product option';
          mainImage.classList.remove('is-cover');
        }
      }
      updatePurchaseTotal();
    });
  });

  (purchaseRoot?.querySelectorAll('[data-variant-choice]') || []).forEach((choice) => {
    choice.addEventListener('click', () => {
      const picker = choice.closest('.variant-picker');
      const input = [...picker.querySelectorAll('input')].find((item) => item.value === choice.dataset.variantId);
      if (!input || input.disabled) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  updatePurchaseTotal();

  */
  const purchaseRoot = document.querySelector('[data-product-purchase]');
  const productForm = purchaseRoot?.querySelector('#wakeplay-product-form');
  const price = purchaseRoot?.querySelector('[data-price]:not(input)');
  const comparePrice = purchaseRoot?.querySelector('[data-compare-price]:not(input)');
  const addToCart = purchaseRoot?.querySelector('.add-to-cart');
  const bundleSelector = purchaseRoot?.querySelector('[data-bundle-selector]');
  const primaryVariantInput = purchaseRoot?.querySelector('[data-bundle-primary-id]');
  const addOnInputs = [...(purchaseRoot?.querySelectorAll('[data-cart-add-on]') || [])];
  const upsellOptions = purchaseRoot?.querySelector('.upsell-options');
  const addOnTarget = purchaseRoot?.querySelector('[data-add-ons-target]');
  const formatMoney = (cents) => `$${(cents / 100).toFixed(2)}`;
  let bundleApi = null;

  if (upsellOptions && addOnTarget) addOnTarget.append(upsellOptions);

  const variants = (() => {
    try { return JSON.parse(bundleSelector?.dataset.variants || '[]'); }
    catch { return []; }
  })();
  const bundleOffers = [...(bundleSelector?.querySelectorAll('[data-bundle-offer]') || [])];
  let activeBundleSize = 1;

  const getVariantForRow = (row) => {
    const choices = [...row.querySelectorAll('[data-bundle-option]')]
      .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
      .map((select) => select.value);
    return variants.find((variant) => variant.available && choices.every((value, index) => variant.options?.[index] === value))
      || variants.find((variant) => choices.every((value, index) => variant.options?.[index] === value))
      || variants[0];
  };

  const getActiveOffer = () => bundleOffers.find((offer) => Number(offer.dataset.bundleSize) === activeBundleSize);
  const getSelectedVariants = () => [...(getActiveOffer()?.querySelectorAll('[data-bundle-row]') || [])]
    .map(getVariantForRow).filter(Boolean);

  const syncFirstItemGallery = (variant) => {
    if (!variant) return;
    const gallery = document.querySelector('[data-product-gallery]');
    const variantThumb = gallery?.querySelector(`[data-gallery-thumb][data-variant-id="${variant.id}"]`);
    if (variantThumb && !variantThumb.classList.contains('is-active')) {
      variantThumb.click();
      return;
    }
    if (document.querySelector('.product-page--babysip')) {
      const thumbs = [...(gallery?.querySelectorAll('[data-gallery-thumb]') || [])];
      const fallback = thumbs[variant.title === 'Pink' ? 1 : 0];
      if (fallback && !fallback.classList.contains('is-active')) fallback.click();
    }
  };

  const updateBundle = ({ syncGallery = true } = {}) => {
    const selectedVariants = getSelectedVariants();
    const productCents = selectedVariants.reduce((sum, variant) => sum + Number(variant.price || 0), 0);
    const activeBundleDiscountCents = Number(getActiveOffer()?.dataset.bundleDiscountCents || 0);
    const discountedProductCents = Math.max(0, productCents - activeBundleDiscountCents);
    const addOnCents = addOnInputs.filter((option) => option.checked)
      .reduce((sum, option) => sum + Number(option.dataset.upsellPriceCents || 0), 0) * selectedVariants.length;
    const total = discountedProductCents + addOnCents;
    const primaryVariant = selectedVariants[0];
    if (primaryVariantInput && primaryVariant) primaryVariantInput.value = primaryVariant.id;
    if (price) {
      price.dataset.priceCents = String(total);
      price.textContent = formatMoney(total);
    }
    if (comparePrice) {
      comparePrice.hidden = true;
      comparePrice.textContent = '';
    }
    if (addToCart) addToCart.textContent = `Add to bag — ${formatMoney(total)}`;
    bundleOffers.forEach((offer) => {
      const isActive = Number(offer.dataset.bundleSize) === activeBundleSize;
      offer.classList.toggle('is-selected', isActive);
      offer.querySelector('[data-bundle-choice]')?.setAttribute('aria-expanded', String(isActive));
      const config = offer.querySelector('.bundle-offer__config');
      if (config) config.hidden = !isActive;
      const offerTotal = [...offer.querySelectorAll('[data-bundle-row]')]
        .map(getVariantForRow).filter(Boolean)
        .reduce((sum, variant) => sum + Number(variant.price || 0), 0);
      const discountCents = Number(offer.dataset.bundleDiscountCents || 0);
      const discountedOfferTotal = Math.max(0, offerTotal - discountCents);
      const totalEl = offer.querySelector('[data-bundle-total]');
      if (totalEl) totalEl.textContent = formatMoney(discountedOfferTotal);
      const compareEl = offer.querySelector('[data-bundle-compare]');
      if (compareEl) {
        compareEl.textContent = formatMoney(offerTotal);
        compareEl.hidden = discountCents <= 0;
      }
      const savingsEl = offer.querySelector('[data-bundle-savings]');
      if (savingsEl) {
        savingsEl.textContent = `You save ${formatMoney(discountCents)}`;
        savingsEl.hidden = discountCents <= 0;
      }
    });
    if (syncGallery) syncFirstItemGallery(primaryVariant);
  };

  bundleOffers.forEach((offer) => {
    offer.querySelector('[data-bundle-choice]')?.addEventListener('click', () => {
      activeBundleSize = Number(offer.dataset.bundleSize);
      updateBundle();
    });
    offer.querySelectorAll('[data-bundle-option]').forEach((select) => {
      select.addEventListener('change', () => {
        const isFirst = Number(select.closest('[data-bundle-row]')?.dataset.bundleRowIndex) === 1;
        updateBundle({ syncGallery: offer === getActiveOffer() && isFirst });
      });
    });
  });
  addOnInputs.forEach((option) => option.addEventListener('change', () => updateBundle({ syncGallery: false })));

  bundleApi = {
    selectVariant(variantId) {
      const variant = variants.find((item) => String(item.id) === String(variantId));
      const row = getActiveOffer()?.querySelector('[data-bundle-row]');
      if (!variant || !row) return;
      [...row.querySelectorAll('[data-bundle-option]')].forEach((select) => {
        const value = variant.options?.[Number(select.dataset.optionIndex)];
        if (value !== undefined) select.value = value;
      });
      updateBundle({ syncGallery: false });
    },
  };

  productForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!addToCart || addToCart.dataset.loading === 'true') return;
    const selectedVariants = getSelectedVariants();
    if (!selectedVariants.length) return;
    const addOns = addOnInputs.filter((option) => option.checked);
    const originalText = addToCart.textContent;
    addToCart.dataset.loading = 'true';
    addToCart.disabled = true;
    addToCart.textContent = 'Adding to bag…';
    try {
      const items = [
        ...selectedVariants.map((variant) => ({ id: Number(variant.id), quantity: 1 })),
        ...addOns.map((option) => ({ id: Number(option.dataset.upsellVariantId), quantity: selectedVariants.length })),
      ];
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error('Could not add bundle.');
      sessionStorage.setItem('useful-joy-cart-drawer-open', 'true');
      window.location.reload();
    } catch (error) {
      addToCart.disabled = false;
      addToCart.dataset.loading = 'false';
      addToCart.textContent = originalText;
      window.alert('We could not add your bundle. Please try again.');
    }
  });

  updateBundle();

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-gallery-main]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const mainFrame = gallery.querySelector('.product-gallery-picker__main');
    const selectImage = (thumb) => {
      if (!mainImage || !thumb) return;
      const imageSource = thumb.dataset.imageSrc || thumb.querySelector('img')?.currentSrc || thumb.querySelector('img')?.src;
      if (!imageSource) return;
      mainImage.src = imageSource;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.alt = thumb.dataset.imageAlt || 'Product photo';
      mainImage.classList.toggle('is-cover', thumb.dataset.imageFit === 'cover');
      thumbs.forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        if (active) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
      if (thumb.dataset.variantId) bundleApi?.selectVariant(thumb.dataset.variantId);
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => selectImage(thumb)));

    const selectRelativeImage = (direction) => {
      const activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      const nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
      selectImage(thumbs[nextIndex]);
    };

    gallery.querySelector('[data-gallery-previous]')?.addEventListener('click', () => selectRelativeImage(-1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => selectRelativeImage(1));

    let swipeStartX = 0;
    mainFrame?.addEventListener('touchstart', (event) => {
      swipeStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    mainFrame?.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - swipeStartX;
      if (Math.abs(distance) < 45 || !thumbs.length) return;
      selectRelativeImage(distance < 0 ? 1 : -1);
    }, { passive: true });
  });

  document.querySelectorAll('[data-testimonial-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('[data-testimonial-slide]')];
    const dots = [...carousel.querySelectorAll('[data-testimonial-dot]')];
    if (slides.length < 2) return;

    let activeIndex = 0;
    const showReview = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === activeIndex));
      dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', String(active));
      });
    };

    dots.forEach((dot, index) => dot.addEventListener('click', () => showReview(index)));
    let swipeStartX = 0;
    carousel.addEventListener('touchstart', (event) => {
      swipeStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - swipeStartX;
      if (Math.abs(distance) < 35) return;
      showReview(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });
    window.setInterval(() => showReview(activeIndex + 1), 5200);
  });

  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerLoader = drawer?.querySelector('[data-cart-drawer-loader]');
  const openCartDrawer = () => {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  };
  const closeCartDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    window.setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 240);
  };
  const setDrawerLoading = (isLoading) => {
    if (!drawerLoader) return;
    drawerLoader.hidden = !isLoading;
    drawer?.classList.toggle('is-loading', isLoading);
  };
  const updateCartDrawer = (cart, line, nextQuantity) => {
    const updatedLine = cart.items.find((item) => item.key === line?.dataset.cartLineKey);
    const linePrice = line?.querySelector('.cart-drawer__item-side b');
    if (linePrice && updatedLine) linePrice.textContent = formatMoney(updatedLine.final_line_price);
    if (nextQuantity === 0) line?.remove();
    else if (line) line.querySelector('.cart-drawer__quantity span').textContent = String(nextQuantity);

    drawer?.querySelectorAll('[data-cart-drawer-count]').forEach((count) => { count.textContent = String(cart.item_count); });
    document.querySelectorAll('a.cart-link span').forEach((count) => { count.textContent = `(${cart.item_count})`; });
    const subtotal = drawer?.querySelector('.cart-drawer__subtotal strong');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) {
      drawer?.querySelector('.cart-drawer__items')?.replaceWith(Object.assign(document.createElement('div'), {
        className: 'cart-drawer__empty',
        innerHTML: '<p>Your bag is empty.</p>',
      }));
      drawer?.querySelector('.cart-drawer__footer')?.remove();
    }
  };

  document.querySelectorAll('a.cart-link[href*="/cart"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      openCartDrawer();
    });
  });
  drawer?.querySelectorAll('[data-cart-drawer-close]').forEach((button) => button.addEventListener('click', closeCartDrawer));
  drawer?.addEventListener('click', async (event) => {
    const quantityButton = event.target.closest('[data-drawer-quantity]');
    const removeButton = event.target.closest('[data-drawer-remove]');
    if (!quantityButton && !removeButton) return;

    const line = event.target.closest('[data-cart-line-key]');
    const key = line?.dataset.cartLineKey;
    if (!key) return;
    const currentQuantity = Number(line.querySelector('.cart-drawer__quantity span')?.textContent || 0);
    const nextQuantity = removeButton ? 0 : Math.max(0, currentQuantity + Number(quantityButton.dataset.drawerQuantity));
    [quantityButton, removeButton].filter(Boolean).forEach((button) => { button.disabled = true; });
    setDrawerLoading(true);

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: nextQuantity }),
      });
      if (!response.ok) throw new Error('Could not update cart.');
      const cart = await response.json();
      updateCartDrawer(cart, line, nextQuantity);
    } catch (error) {
      [quantityButton, removeButton].filter(Boolean).forEach((button) => { button.disabled = false; });
      window.alert('We could not update your cart. Please try again.');
    } finally {
      setDrawerLoading(false);
    }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCartDrawer(); });
  if (sessionStorage.getItem('useful-joy-cart-drawer-open') === 'true') {
    sessionStorage.removeItem('useful-joy-cart-drawer-open');
    openCartDrawer();
  }

  const sizingChartModal = document.querySelector('[data-sizing-chart-modal]');
  const openSizingChart = () => {
    if (!sizingChartModal) return;
    sizingChartModal.hidden = false;
    sizingChartModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sizing-chart-open');
    sizingChartModal.querySelector('[data-sizing-chart-close]')?.focus();
  };
  const closeSizingChart = () => {
    if (!sizingChartModal) return;
    sizingChartModal.hidden = true;
    sizingChartModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sizing-chart-open');
  };
  document.querySelectorAll('[data-sizing-chart-open]').forEach((button) => button.addEventListener('click', openSizingChart));
  sizingChartModal?.querySelectorAll('[data-sizing-chart-close]').forEach((button) => button.addEventListener('click', closeSizingChart));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeSizingChart(); });

  const countdown = document.querySelector('[data-countdown]');
  if (countdown) {
    const duration = 60 * 60 * 1000;
    const storageKey = 'shooting-alarm-clock-launch-end';
    let endTime = Number(sessionStorage.getItem(storageKey));

    if (!endTime || endTime <= Date.now()) {
      endTime = Date.now() + duration;
      sessionStorage.setItem(storageKey, String(endTime));
    }

    const renderCountdown = () => {
      let remaining = endTime - Date.now();
      if (remaining <= 0) {
        endTime = Date.now() + duration;
        sessionStorage.setItem(storageKey, String(endTime));
        remaining = duration;
      }
      const totalSeconds = Math.ceil(remaining / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      countdown.textContent = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
    };

    renderCountdown();
    window.setInterval(renderCountdown, 1000);
  }
});

window.addEventListener('pageshow', (event) => {
  if (event.persisted) window.location.reload();
});
